import { render } from "./property-tourcta.vue?vue&type=template&id=bdc7c63e"
import script from "./property-tourcta.js?vue&type=script&lang=js"
export * from "./property-tourcta.js?vue&type=script&lang=js"

import "./property-tourcta.vue?vue&type=style&index=0&id=bdc7c63e&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__